const CornerLabel = () => {
    const isTestEnvironment = ['test', 'dev', 'staging'].includes((process.env.VITE_STAGE ?? '').toLowerCase());
    if (isTestEnvironment) {
        return (
        <div className="absolute top-0 left-0 w-0 h-0 z-50 pointer-events-none">
          <div className="border-l-[60px] border-l-red-500 border-b-[60px] border-b-transparent"></div>
          <style>
            {`.github-corner:hover .octo-arm{animation:octocat-wave 560ms ease-in-out}@keyframes octocat-wave{0%,100%{transform:rotate(0)}20%,60%{transform:rotate(-25deg)}40%,80%{transform:rotate(10deg)}}@media (max-width:500px){.github-corner:hover .octo-arm{animation:none}.github-corner .octo-arm{animation:octocat-wave 560ms ease-in-out}}`}
          </style>
          {/* Ribbon text */}
          <div className="absolute top-2 left-1 text-white text-[10px] font-bold transform -rotate-45 whitespace-nowrap">
            {process.env.VITE_STAGE ?? 'TEST'}
          </div>
        </div>
      )
    }
}

export default CornerLabel;